export default __webpack_public_path__ + "static/media/monkey1.09db6a49.JPG";